import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';

interface Props {
  lang: 'en' | 'ru' | 'it' | 'fr';
}

const photos = [
  { src: 'https://63900.selcdn.ru/iv/portfolio/photo/Yoshinkan-Aikido-logo.png', alt: 'Aikido Yoshinkan' },
  { src: 'https://63900.selcdn.ru/iv/portfolio/photo/SNV30908.JPG', alt: 'Photo 2' },
  { src: 'https://63900.selcdn.ru/iv/portfolio/photo/IMG_3956.JPG', alt: 'Photo 3' },
  { src: 'https://63900.selcdn.ru/iv/portfolio/photo/IMG_3458.JPG', alt: 'Photo 4' },
  { src: 'https://63900.selcdn.ru/iv/portfolio/photo/IMG_3435.JPG', alt: 'Photo 5' },
  { src: 'https://63900.selcdn.ru/iv/portfolio/photo/IMG_1103.JPG', alt: 'Photo 6' },
  { src: 'https://63900.selcdn.ru/iv/portfolio/photo/DSC08244.jpg', alt: 'Photo 7' },
];

export default function Hobby({ lang }: Props) {
  const { t } = useTranslation('hobby');
  const tc = useTranslation('common').t;

  return (
    <Layout lang={lang}>
      <div className="blog-post">
        <h2 className="blog-post-title">{t('title')}</h2>
        <p className="blog-post-meta">
          <Link to={lang === 'en' ? '/' : `/${lang}`}>{tc('backToMain')}</Link>
          &nbsp;|&nbsp; <a href="https://github.com/microbusiness" target="_blank" rel="noopener noreferrer">{tc('github')}</a>
        </p>
        <hr />

        <p><strong>{t('activeRest')}</strong></p>
        <p>{t('activities')}</p>

        <div className="row mt-3">
          {photos.map(({ src, alt }) => (
            <div key={src} className="col-md-4 mb-3">
              <img src={src} alt={alt} className="img-fluid rounded" />
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
